import { render, staticRenderFns } from "./sing-up-status.vue?vue&type=template&id=68a1bb3a&scoped=true&"
import script from "./sing-up-status.vue?vue&type=script&lang=js&"
export * from "./sing-up-status.vue?vue&type=script&lang=js&"
import style0 from "./sing-up-status.vue?vue&type=style&index=0&id=68a1bb3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a1bb3a",
  null
  
)

export default component.exports